import { createAction } from 'redux-actions';
import * as actionTypes from './constants';

export const initializeOrder = createAction(actionTypes.INITIALIZE_ORDER);
export const initializeOrderSuccess = createAction(actionTypes.INITIALIZE_ORDER_SUCCESS);
export const initializeOrderFailure = createAction(actionTypes.INITIALIZE_ORDER_FAILURE);

export const createOrder = createAction(actionTypes.CREATE_ORDER);
export const createOrderSuccess = createAction(actionTypes.CREATE_ORDER_SUCCESS);
export const createOrderFailure = createAction(actionTypes.CREATE_ORDER_FAILURE);

export const answer = createAction(actionTypes.ANSWER);

export const setDefaults = createAction(actionTypes.SET_DEFAULTS);
export const setIndicatorDefaults = createAction(actionTypes.SET_INDICATOR_DEFAULTS);

export const toggleIndicatorWizard = createAction(actionTypes.TOGGLE_INDICATOR_WIZARD);

export const resetError = createAction(actionTypes.RESET_ERROR);
